import React from 'react';

export default function WebUiHeader() {
  return (
    <div className="absolute z-10 flex h-20 w-full items-center justify-between bg-webui-primary px-5">
      <div className="min-w-0 text-white">
        <div className="text-3xl font-bold leading-8">ROQSTAR</div>
        <div className="text-2xl font-bold leading-6">
          Managed Ethernet Switch
        </div>
      </div>
      <a
        href="/"
        className="rounded-md bg-webui-bg px-4 py-2 text-sm font-bold transition-colors duration-200 hover:bg-webui-secondary/80"
      >
        Back to topology
      </a>
      <img
        src="/logo-white.png"
        alt="ROQSTAR"
        className="h-16 w-auto max-w-[300px] shrink-0 object-contain"
      />
    </div>
  );
}
